import React from "react";
import {useDispatch, useSelector} from "react-redux";
import BubblyCustomSelect from "../../../../common/BubblyCustomSelect";
import {addSkipGroupToQuestionAtIdx, removeSkipGroupFromQuestionAtIdx} from "../../../../../slices/surveyEditorSlice";

function EditQuestionLogic(props) {

    const dispatch = useDispatch();
    const questionsList = useSelector((state)=> state.survey.questions);

    const filteredQuestionsList = questionsList.filter((element, index) => {
        return index < props.idx && ["singleChoice", "multipleChoice"].includes(element.type);
    });

    let selectedQuestionIndex;
    let selectedChoicesIndexes;

    const getSelectionIndexesArrayForChoices = (skipQuestion, choicesValuesArray) => {
        let choicesArray = skipQuestion.choices;
        let options = skipQuestion.options;
        let indexesArray = [];
        for(let i = 0 ; i < choicesArray.length; i++) {
            if(choicesValuesArray.includes(choicesArray[i].value)) {
                indexesArray.push(i);
            }
        }

        // Adding DKNA index to indexesArray if DKNA is selected
        if(options && options.noDKNA && options.noDKNA === "false" && choicesValuesArray.includes("999")) {
            indexesArray.push(choicesArray.length);
        }

        return indexesArray;
    };

    const {skipGroup} = props.questionData;
    if(skipGroup) {
        let skipQId = skipGroup[0].skipArray[0].question_id;
        let skipValuesArray = skipGroup[0].skipArray[0].value;

        selectedQuestionIndex =  filteredQuestionsList.findIndex((elem) => elem.id === skipQId);
        selectedChoicesIndexes = getSelectionIndexesArrayForChoices(filteredQuestionsList[selectedQuestionIndex], skipValuesArray);
    } else {
        selectedQuestionIndex = undefined;
        selectedChoicesIndexes = [];
    }

    const handleSelectedQuestionChange = (selectedItemIndex) => {
        if(typeof selectedItemIndex !== "undefined") {
            const dispatchPayload = {
                idx: props.idx,
                skipQuestionData: filteredQuestionsList[selectedItemIndex],
                skipValuesArray: []
            };
            dispatch(addSkipGroupToQuestionAtIdx(dispatchPayload));
        } else {
            clearSelectedItemsAndSkipRule();
        }
    };

    const handleSelectedChoicesChange = (selectedItemsIndexes) => {
        let skipValuesArray = selectedItemsIndexes.map((mapItem, i) => {
            let isIndexOfDKNA = mapItem === filteredQuestionsList[selectedQuestionIndex].choices.length;
            if(!isIndexOfDKNA) {
                return filteredQuestionsList[selectedQuestionIndex].choices[mapItem].value;
            } else {
                return "999";
            }
        });

        const dispatchPayload = {
            idx: props.idx,
            skipQuestionData: filteredQuestionsList[selectedQuestionIndex],
            skipValuesArray: skipValuesArray
        };
        dispatch(addSkipGroupToQuestionAtIdx(dispatchPayload));
    };

    const clearSelectedItemsAndSkipRule = () => {
        dispatch(removeSkipGroupFromQuestionAtIdx({idx: props.idx}));
    };

    const buildQuestionSelectorDataList = (rawDataList) => {
        return rawDataList.map((element, index) => {
            return {
                uniqueId: "question_" + props.questionData.id + "_logic_q_item_unique_id_" + element.id,
                text: element.id + ". " + element.question,
                questionType: element.type
            }
        });
    };

    const buildChoicesSelectorDataList = (rawQuestionData) => {
        const {choices, options} = rawQuestionData;
        const choicesSelectorDataList = choices.map((element, index) => {
            return {
                uniqueId: rawQuestionData.id + "_choice_unique_id_" + element.value,
                text: element.value + ". " + element.label
            }
        });

        // Adding DKNA option in dataList if question does contain DKNA
        if(options && options.noDKNA && options.noDKNA === "false") {
            choicesSelectorDataList.push({
                uniqueId: rawQuestionData.id + "_choice_unique_id_" + 999,
                text: "Don’t know/ No Answer"
            });
        }

        return choicesSelectorDataList;
    };

    const questionsSelectorData = buildQuestionSelectorDataList(filteredQuestionsList);
    let choicesSelectorData = [];
    if(typeof selectedQuestionIndex !== "undefined" && selectedQuestionIndex >= 0) {
        choicesSelectorData = buildChoicesSelectorDataList(filteredQuestionsList[selectedQuestionIndex]);
    }

    return (
        <div className="questionaire__builder__question__content questionaire__builder__question__content--show questionaire__builder__question__content--dark questionaire__builder__question__content--minHeight">
            <div className="questionaire__builder__question__content__row">
                {<BubblyCustomSelect id={"skip_questions_selector_" + props.questionData.id}
                                     title={"Show " + props.questionData.id + " only if answers at…"}
                                     selectPlaceholder={"Choose question"}
                                     dataItemsList={questionsSelectorData}
                                     selectedItemIndex={selectedQuestionIndex}
                                     handleSelectedItemIndexChange={handleSelectedQuestionChange}
                />}
                {<BubblyCustomSelect id={"skip_choices_selector_" + props.questionData.id}
                                     title={"IS"}
                                     selectPlaceholder={"Choose choice"}
                                     dataItemsList={choicesSelectorData}
                                     multiple={true}
                                     selectedItemsIndexes={selectedChoicesIndexes}
                                     handleSelectedItemsIndexesChange={handleSelectedChoicesChange}
                />}
                <div className="selector_container">
                    <a href="#" onClick={(event) => {event.preventDefault();clearSelectedItemsAndSkipRule()}} className="clear_btn">Clear</a>
                </div>
            </div>
        </div>
    );
}

export default EditQuestionLogic;